/*
 * File: headerFix.ts
 * Author: Austin Robinson
 * Date Created: 7/30/2022
 * Copyright (c) DrivingDoc 2022
 */

export default function headerFix() {
  const resourceHeader = document.getElementsByClassName(
    'fc-scrollgrid-section fc-scrollgrid-section-header  fc-scrollgrid-section-sticky',
  );
  const toolbar = document.getElementsByClassName('fc-header-toolbar fc-toolbar fc-toolbar-ltr');
  const navBar = document.getElementsByClassName('MuiAppBar-positionSticky');
  if (toolbar.length > 0 && resourceHeader.length > 0) {
    (resourceHeader[0] as HTMLElement).style.zIndex = '100';
    (resourceHeader[0] as HTMLElement).style.backgroundColor = '#FFFFFF';
    (resourceHeader[0] as HTMLElement).style.position = 'sticky';
    (resourceHeader[0] as HTMLElement).style.top = `${toolbar[0].clientHeight - 1 + (navBar[0]?.clientHeight ?? 0)}px`;
    // console.log(`Old Offset: ${toolbar[0].clientHeight}`);
    // console.log(`New Offset: ${toolbar[0].clientHeight - 1 + (navBar[0]?.clientHeight ?? 0)}`);
    (toolbar[0] as HTMLElement).style.top = `${navBar[0]?.clientHeight ?? 0}px`;
  }
}
